import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ag-page_assets position-relative" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { for: "apiKey" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "apiUrl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1)
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_card, { module: _ctx.module }, {
      "hash-lookup": _withCtx(() => [
        _createVNode(_component_Form, {
          class: "p-4",
          onSubmit: _ctx.submitFunction,
          "validation-schema": _ctx.schema,
          "initial-values": _ctx.formValues
        }, {
          default: _withCtx(({ meta }) => [
            _createVNode(_component_Field, { name: "apiKey" }, {
              default: _withCtx(({ field, meta }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("label", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.$t("apiKey")) + " ", 1),
                    _hoisted_4
                  ]),
                  _createElementVNode("input", _mergeProps({
                    name: "apiKey",
                    type: "text",
                    maxlength: "191"
                  }, field, {
                    class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                    id: "apiKey"
                  }), null, 16),
                  _createVNode(_component_error_message, {
                    class: "form-error-label",
                    name: "apiKey"
                  })
                ])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_Field, { name: "apiUrl" }, {
              default: _withCtx(({ field, meta }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t("apiUrl")) + " ", 1),
                    _hoisted_7
                  ]),
                  _createElementVNode("input", _mergeProps({
                    name: "apiUrl",
                    type: "text",
                    maxlength: "191"
                  }, field, {
                    class: ["form-control", { 'form-error-input': meta.touched && !meta.valid }],
                    id: "apiUrl"
                  }), null, 16),
                  _createVNode(_component_error_message, {
                    class: "form-error-label",
                    name: "apiUrl"
                  })
                ])
              ]),
              _: 2
            }, 1024),
            _createElementVNode("button", {
              type: "submit",
              disabled: !meta.valid,
              class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary"
            }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_8)
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"])
      ]),
      _: 1
    }, 8, ["module"])
  ]))
}